/**
 * These constants are mostly classNames used by our components and by
 * WorkflowsReactUI for things other than just styling. For example,
 * the Zoom and Pan decorators make use of the classNames as
 * identifiers.
 */

export const FIRST_NODE_EDGE = 'enrollment-edge-0';
export const FIRST_NODE = 'enrollment';
export const VIRTUAL_ANCHORED_DELAY_NODE_EDGE = 'classic-virtual-anchor-delay-edge-0';
export const VIRTUAL_ANCHORED_DELAY_NODE = 'classic-virtual-anchor-delay';
export const VIRTUAL_SCHEDULED_ENROLLMENT_NODE_EDGE = 'virtual-scheduled-enrollment-edge-0';
export const VIRTUAL_SCHEDULED_ENROLLMENT_NODE = 'virtual-scheduled-enrollment';
export const SINGLE_NODE = 'single-node';
export const BUILDER_CARD_CONTAINER = 'builder-card-container';
export const ADD_BUTTON_CONTAINER = 'add-button-container';
export const DIRECTED_GRAPH_FINISH_LINE = 'directed-graph-finish-line';
export const BRANCH_NODE_CHILD = 'branch-node-child';
export const BRANCH_NODES = 'branch-nodes';
export const EMPTY_CONTENT_CARD = 'empty-content-card';
export const STARTING_NODE_ID = 'starting-node';